const principles = [
  {
    icon: "ri-magic-fill",
    title: "编辑精选，笑点把关",
    desc: "每个栏目都由懂漫画的编辑人工挑选，只推真正好笑、脑洞够大的作品，拒绝烂俗注水。",
  },
  {
    icon: "ri-refresh-line",
    title: "每日更新，追更不愁",
    desc: "精选作品持续更新，神转折一话接一话，点开就能收获快乐，常看常新。",
  },
  {
    icon: "ri-emotion-happy-fill",
    title: "轻松上头，治愈解压",
    desc: "用无厘头与魔性画风帮你卸下疲惫，把不开心统统笑走，越看越有精神。",
  },
];

const testimonials = [
  {
    name: "追更的小张",
    tag: "沙雕漫画爱好者",
    text: "下班刷《老板今天又疯了》能笑到肚子疼，打工人痛点全被拿捏了，已安利给整个部门。",
    color: "bg-secondary-100 text-secondary-800",
  },
  {
    name: "夜猫子阿凯",
    tag: "神转折重度用户",
    text: "《外卖小哥的逆袭》每话结尾都在打脸，根本停不下来。开心漫画网的更新速度也太快了。",
    color: "bg-primary-100 text-primary-700",
  },
  {
    name: "阿夏",
    tag: "脑洞漫画迷",
    text: "这里的好多作品脑洞清奇到离谱，画风魔性但越看越上头，是每晚睡前的快乐源泉。",
    color: "bg-accent-100 text-accent-700",
  },
  {
    name: "咸鱼社畜",
    tag: "魔性画风粉",
    text: "《社畜的自我修养》简直是我本人，句句扎心又好笑。终于找到能共情又搞笑的漫画社区了。",
    color: "bg-background-200 text-foreground-700",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="relative w-full bg-background-50 py-12 md:py-16">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-6 md:mb-10">
          <span className="inline-flex items-center gap-1.5 text-accent-600 text-sm font-bold mb-1">
            <i className="ri-sparkling-fill" aria-hidden="true"></i>
            关于我们
          </span>
          <h2 className="font-heading text-foreground-950 text-2xl md:text-4xl">
            一个只为让你开怀的漫画社区
          </h2>
          <p className="text-foreground-600 text-sm mt-3 max-w-2xl mx-auto leading-relaxed">
            开心漫画网专注沙雕搞笑、无厘头脑洞与神转折剧情，网罗魔性画风与奇葩设定。
            我们相信好的快乐不必烧脑，优质的沙雕漫画值得被更多人看见，于是把每本经得起笑点考验的作品送到你面前。
          </p>
        </div>

        {/* Principles */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mb-10">
          {principles.map((p) => (
            <div
              key={p.title}
              className="rounded-2xl bg-background-100 border-2 border-background-200 p-5 md:p-6 hover:border-primary-300 transition"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500 text-background-50 text-2xl mb-4 shadow-comic-sm">
                <i className={p.icon} aria-hidden="true"></i>
              </span>
              <h3 className="font-heading text-foreground-950 text-lg">{p.title}</h3>
              <p className="text-foreground-600 text-sm mt-2 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="relative rounded-3xl bg-background-100 halftone p-5 md:p-8">
          <div className="flex items-center gap-2 mb-5">
            <i className="ri-double-quotes-l text-accent-500 text-2xl" aria-hidden="true"></i>
            <h3 className="font-heading text-foreground-950 text-lg md:text-xl">读者口碑</h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="rounded-2xl bg-background-50 border-2 border-background-200 p-4 md:p-5"
              >
                <blockquote className="text-foreground-700 text-sm leading-relaxed">
                  “{t.text}”
                </blockquote>
                <figcaption className="flex items-center gap-3 mt-3">
                  <span className="w-9 h-9 flex items-center justify-center rounded-full font-heading text-background-50 bg-primary-500">
                    {t.name.charAt(0)}
                  </span>
                  <div>
                    <p className="text-sm text-foreground-900 font-bold">{t.name}</p>
                    <p className={`text-[11px] inline-block px-2 py-0.5 rounded-md ${t.color}`}>
                      {t.tag}
                    </p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}